import { LineBreakTransformer } from "./LineBreakTransformer";
import { ParsedWeightData, Weighbridge } from "./Weighbridge";

export class Diva11Weighbridge implements Weighbridge {
    public baudRate: number = 9600;
    public lineBreakSeparator: string = '\r\n';
    public lineBreakTransformer?: LineBreakTransformer;

    public parse(buffer: string): ParsedWeightData {
        const modes = [buffer.slice(0, 1)];
        const weight = parseInt(buffer.slice(1, 7));
        const unit = 'kg';

        return {
            modes,
            weight,
            unit,
        };
    }

    public getLineBreakTransformer() {
        return this.lineBreakTransformer ??= new LineBreakTransformer(this.lineBreakSeparator);
    }
}